import type { IconData } from '@stacksjs/iconify-core'

export const re1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#fff\" d=\"M0 0h512v512H0z\"/><path fill=\"#00267f\" d=\"M0 0h170.7v512H0z\"/><path fill=\"#f31830\" d=\"M341.3 0H512v512H341.3z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default re1x1
